<div id="popup" [ngClass]="currentStyle">
  <div class="d-flex align-items-baseline">
    <span class="message-header mr-3" [ngClass]="currentStyle">{{ header | translate }}</span>
    <span class="message-body mr-3">{{ message | translate }}</span>
    <button class="close align-self-center" (click)="close()"></button>
  </div>
</div>
